module.exports = __webpack_public_path__ + "img/img_filosofia.0f1eb6df.png";